/* eslint-disable react/require-default-props */

'use client';

import NextImage from 'next/image';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './Image.module.scss';
import '../Utils/css';

/**
 * A simple Image
 */
export default function Image({
  imageSrc,
  defaultSrc,
  className,
  containerClassName,
  alt = '',
  fill = true,
  container = true,
  ...childProps
}) {
  const [src, setSrc] = useState(imageSrc);

  const replaceImgWithError = () => {
    setSrc(defaultSrc);
  };

  useEffect(() => {
    setSrc(imageSrc);
  }, [imageSrc]);

  return (
    <>
      {container && (
        <div className={[styles.Image, containerClassName].css()}>
          <NextImage
            className={[styles['image__next-image'], className].css()}
            onError={replaceImgWithError}
            placeholder={defaultSrc ? 'blur' : 'empty'}
            blurDataURL={defaultSrc || null}
            src={src || defaultSrc}
            fill={fill}
            alt={alt}
            {...childProps}
          />
        </div>
      )}
      {!container && (
        <NextImage
          className={[styles['image__next-image'], className].css()}
          onError={replaceImgWithError}
          placeholder={defaultSrc ? 'blur' : 'empty'}
          blurDataURL={defaultSrc || null}
          src={src || defaultSrc}
          fill={fill}
          alt={alt}
          {...childProps}
        />
      )}
    </>

  );
}

Image.propTypes = {
  /**
   * The source URL of the image to display.
   */
  imageSrc: PropTypes.string,

  /**
   * The fallback source URL if the image fails to load.
   */
  defaultSrc: PropTypes.string,

  /**
   * The alt text for the image (for accessibility).
   */
  alt: PropTypes.string,

  /**
   * Whether to use `Next.js`'s `fill` property for responsive images.
   */
  fill: PropTypes.bool,

  /**
   * Whether to wrap the image in a styled container.
   */
  container: PropTypes.bool,

  /**
   * Additional classes for the image container.
   */
  containerClassName: PropTypes.string,

  /**
   * Additional classes for the `NextImage` element.
   */
  className: PropTypes.string,
};
